import { getTranslated } from "utils";

export const CONDITION_TYPES = [
    'SEGMENT',
    'CONFIGURATION',
    'CODE_PROMO',
    'PACKAGE',
    'PRODUCT_GROUP',
    'PROPERTY_VALUE',
    'CUSTOMER',
    'BILLING_ACCOUNT',
    'CART_AMOUNT',
    'FIRST_ORDER',
    'CUSTOMER_MONTH_INVOICE',
    'CUSTOMER_YEAR_INVOICE',
    'CUSTOMER_CATEGORY_TYPE',
];

export const ENABLED_CONDITION_TYPES = [
    'SEGMENT',
    'CONFIGURATION',
    'PACKAGE',
    'CODE_PROMO',
    'PRODUCT_GROUP',
    'PROPERTY_VALUE',
    'CUSTOMER',
    'CART_AMOUNT',
    'FIRST_ORDER',
    'BILLING_ACCOUNT',
    'CUSTOMER_CATEGORY_TYPE',
];

export const OPERATORS = [
    'EQUAL',
    'MORE_THAN_OR_EQUAL',
    'LESS_THAN_OR_EQUAL',
    'IN_LIST',
    'EXCEPT',
    'BETWEEN', // ! remove later
];

export const OPERATORS_TYPES = {
    SEGMENT: [3, 4],
    CONFIGURATION: [3, 4],
    CODE_PROMO: [3, 4],
    PACKAGE: [3, 4],
    PRODUCT_GROUP: [3, 4],
    PROPERTY_VALUE: [3, 4],
    CUSTOMER: [3, 4],
    BILLING_ACCOUNT: [3, 4],
    CART_AMOUNT: [1, 2],
    FIRST_ORDER: [0],
    CUSTOMER_MONTH_INVOICE: [1, 2], // ! remove later
    CUSTOMER_YEAR_INVOICE: [1, 2], // ! remove later
    CUSTOMER_CATEGORY_TYPE: [3, 4],
};

export const MODES = {
    SEGMENT: 'multiple',
    CONFIGURATION: 'multiple',
    CODE_PROMO: 'tags',
    PACKAGE: 'multiple',
    PRODUCT_GROUP: 'multiple',
    PROPERTY_VALUE: 'multiple',
    CUSTOMER: 'multiple',
    BILLING_ACCOUNT: 'multiple',
    CUSTOMER_CATEGORY_TYPE: 'multiple',
};

export const PROPERTY_TITLE = {
    SEGMENT: 'title',
    CONFIGURATION: 'name.translate',
    PACKAGE: 'name',
    PRODUCT_GROUP: 'name',
    PROPERTY_VALUE: 'name.translate',
    CODE_PROMO: 'conditions_groups.conditions.value',
    CUSTOMER: 'name',
    BILLING_ACCOUNT: 'name',
};

export const TRANSLATED_FIELDS = {
    type: 'discount.type',
    operator: 'discount.operator',
    value: 'discount.value',
};

export const COLOR_TAGS = {
    SEGMENT: 'magenta',
    CONFIGURATION: 'orange',
    CODE_PROMO: 'volcano',
    PACKAGE: 'red',
    PRODUCT_GROUP: 'blue',
    PROPERTY_VALUE: 'cyan',
    CUSTOMER: 'geekblue',
    BILLING_ACCOUNT: 'purple',
    CART_AMOUNT: 'green',
    FIRST_ORDER: 'lime',
    CUSTOMER_MONTH_INVOICE: 'magenta',
    CUSTOMER_YEAR_INVOICE: 'gold',
    CUSTOMER_CATEGORY_TYPE: 'blue',
};

export const APIS = {
    SEGMENT: process.env.REACT_APP_REST,
    CONFIGURATION: process.env.REACT_APP_REST,
    PACKAGE: process.env.REACT_APP_REST,
    PRODUCT_GROUP: process.env.REACT_APP_REST,
    PROPERTY_VALUE: process.env.REACT_APP_REST,
    CODE_PROMO: process.env.REACT_APP_REST,
    CUSTOMER: process.env.REACT_APP_REST_ORDERS,
    BILLING_ACCOUNT: process.env.REACT_APP_REST_ORDERS,
};

export const ROUTES = {
    SEGMENT: 'segment',
    CONFIGURATION: 'configuration',
    PACKAGE: 'packages',
    PRODUCT_GROUP: 'products-groups',
    PROPERTY_VALUE: 'properties-values',
    CODE_PROMO: 'discounts',
    CUSTOMER: 'customers',
    BILLING_ACCOUNT: 'addresses',
};

export const COMPONENTS = {
    SEGMENT: 'select',
    CONFIGURATION: 'select',
    CODE_PROMO: 'select',
    PACKAGE: 'select',
    PRODUCT_GROUP: 'select',
    PROPERTY_VALUE: 'select',
    CUSTOMER: 'select',
    BILLING_ACCOUNT: 'select',
    CUSTOMER_MONTH_INVOICE: null,
    CUSTOMER_YEAR_INVOICE: null,
    CART_AMOUNT: 'number',
    FIRST_ORDER: null,
    CUSTOMER_CATEGORY_TYPE: 'select_price_list',
};

export const DISPLAY_VALUE = {
    CODE_PROMO: v => v,
    CART_AMOUNT: v => `${v} €`,
    CUSTOMER_CATEGORY_TYPE: (v, locale) => getTranslated(`global.mercuryflooring.${v}`, locale),
};

export const SELL_PRICES_STANDARDS = ['STANDARD', 'STANDARD_2', 'STANDARD_3', 'STANDARD_4'];
